import { MODIFY_CART_GIFT_CARDS_ERROR, MODIFY_CART_GIFT_CARDS_SUCCESS, MODIFY_CART_GIFT_CARDS_REQUEST } from '../types';
import { useHelper } from '../helpers';
export const modifyGiftCardsRequest = details => ({
  type: MODIFY_CART_GIFT_CARDS_REQUEST,
  giftCardDetails: details
});
export const modifyGiftCardsSuccess = (cart, response) => ({
  type: MODIFY_CART_GIFT_CARDS_SUCCESS,
  data: cart,
  response
});
export const modifyGiftCardsError = function (error) {
  let meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: MODIFY_CART_GIFT_CARDS_ERROR,
    error: true,
    meta,
    payload: error
  };
};
export const modifyGiftCards = options => {
  const {
    giftCards
  } = options;
  return async (dispatch, getState, _ref) => {
    let {
      chord
    } = _ref;
    const {
      withCart
    } = useHelper(dispatch, getState);
    try {
      dispatch(modifyGiftCardsRequest({
        giftCards
      }));
      const response = await withCart(chord.oms.updateGiftCards)({
        giftCards
      });
      const updatedCart = await withCart(chord.oms.getOrder)();
      dispatch(modifyGiftCardsSuccess(updatedCart, response));
      return updatedCart;
    } catch (error) {
      dispatch(modifyGiftCardsError(error));
      throw error;
    }
  };
};